const SemVer = require('../classes/semver')
const compareBuild = (a, b, loose) => {
  const versionA = new SemVer(a, loose)
  const versionB = new SemVer(b, loose)
  return versionA.compare(versionB) || versionA.compareBuild(versionB)
}
module.exports = compareBuild



//////////////////
// WEBPACK FOOTER
// ./~/jsonwebtoken/~/semver/functions/compare-build.js
// module id = 199
// module chunks = 1